import React from 'react';
import { Link } from "react-router-dom";
import DocsVideo from '../reusable_components/DocsVideo';

import classroom_view_navigate_video from '../videos/classroom_view_navigate_video.mov';
import classroom_view_find_video from '../videos/classroom_view_find_video.mov';
import classroom_view_move_section_video from '../videos/classroom_view_move_section_video.mov';
import classroom_view_create_section_video from '../videos/classroom_view_create_section_video.mov';
import classroom_view_quick_view_video from '../videos/classroom_view_quick_view_video.mov';

export default function ClassroomViewDocs({ topic, setTopic, schoolType, embedded = false }) {
	const validTopics = ['classroom_view_basics'];
	const classroomViewTopic = embedded ? 'classroom_view_basics' : (validTopics.includes(topic) ? topic : 'default');

	const chooseClassroomViewTopic = (newTopic) => {
		if (classroomViewTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}

		scrollToInstructions('topOfThePage');
	};

	const scrollToInstructions = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<div className='documentation-page'>
			<div id='topOfThePage'></div>
			{!embedded &&
				<>
					<p>Use Classroom View to review schedule placements by room and time.</p>
					<p className='documentation-question-heading'>What would you like help with?</p>
					<div className='choose-topic' style={{ margin: '0px 0px 10px 0px' }}>
						<Link className={`choose-topic-btn ${classroomViewTopic === 'classroom_view_basics' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/magnetboard/classroom_view/${classroomViewTopic === 'classroom_view_basics' ? 'null' : 'classroom_view_basics'}`} onClick={() => chooseClassroomViewTopic('classroom_view_basics')}>Classroom view basics</Link>
					</div>
				</>
			}

			{classroomViewTopic === 'classroom_view_basics' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Classroom View</h2>
				<div className='documentation-question-heading'>What would you like help with?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('classroom_view_navigate')}>Set up your view</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('classroom_view_find')}>Find data quickly</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('classroom_view_move_section')}>Move existing sections</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('classroom_view_create_section')}>Create a new section</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('teacher_view_quick_view')}>See section Quick View/Conflicts</div>
				</div>

				<div id='classroom_view_navigate' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Set up your view</div>
					<div className='documentation-step-text'>Start by choosing <span className='turquoise-text'>Classroom View</span>.</div>
					<div className='documentation-step-text'>If you have a schedule that has different rotations on different days of your cycle, then you will also have the option to choose <span className='turquoise-text'>Period View</span> or <span className='turquoise-text'>Day View</span>. Period View shows you you're rotation periods, and Day View shows you specific days in your rotation.</div>
					<DocsVideo src={classroom_view_navigate_video}></DocsVideo>
				</div>

				<div id='classroom_view_find' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Find data quickly</div>
					<div className='documentation-step-text'>Use the search bar to find classrooms or courses. Search by classroom name, course name, or course code.</div> 
					<div className='documentation-step-text'>You can also use the filter menu to filter the magnetboard by departments, classrooms, singleton/doubleton, or labs.</div>
					<DocsVideo src={classroom_view_find_video}></DocsVideo>
				</div>

				<div id='classroom_view_move_section' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Move existing sections</div>
					<div className='documentation-step-text'>To change a section's period, just drag it to the new period. This updates placement and recalculates conflicts/match percent.</div>
					<DocsVideo src={classroom_view_move_section_video}></DocsVideo>
				</div>

				<div id='classroom_view_create_section' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Create a new section</div>
					<div className='documentation-step-text'>Use the plus icon in the bottom right of a period to add a new section.</div>
					<DocsVideo src={classroom_view_create_section_video}></DocsVideo>
				</div>
				
				<div id='classroom_view_quick_view' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>See section Quick View/Conflicts</div>
					<div className='documentation-step-text'>To see a quick overview of a section's details (including any conflicts), single click on a section. It should automatically open the section Quick View screen. This will also highlight the section and any connected/linked sections, so you can easily see what section you selected.</div>
					<div className='documentation-step-text'>To close the section Quick View, click on "Close" at the top right of the quick view.</div>
					<DocsVideo src={classroom_view_quick_view_video}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
